import { render } from "./InputDate.vue?vue&type=template&id=1a956b05&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"

import "./InputDate.vue?vue&type=style&index=0&id=1a956b05&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a956b05"

export default script